function normalizeValue(value) {
  if (value === null || value === undefined) {
    return ''
  }

  const normalized = String(value).trim()
  return normalized
}

export function getDoctorPrimaryRoleInOrg(doctor) {
  if (!doctor || typeof doctor !== 'object') {
    return ''
  }

  const directRole = normalizeValue(doctor.role_in_org)
  if (directRole) {
    return directRole
  }

  const memberships = Array.isArray(doctor.organization_memberships)
    ? [...doctor.organization_memberships]
    : []

  return memberships
    .sort((a, b) => Number(Boolean(b?.is_primary)) - Number(Boolean(a?.is_primary)))
    .map((membership) => normalizeValue(membership?.role_in_org))
    .find(Boolean) || ''
}

export function getDoctorPrimarySpecialization(doctor) {
  if (!doctor || typeof doctor !== 'object') {
    return ''
  }

  const primarySpecialization = normalizeValue(
    doctor.primary_specialization_name || doctor.primary_specialization_ru || doctor.primary_specialization || doctor.specialization_name
  )
  if (primarySpecialization) {
    return primarySpecialization
  }

  const roleInOrg = getDoctorPrimaryRoleInOrg(doctor)
  const specialization = normalizeValue(doctor.specialization)

  if (specialization && specialization !== roleInOrg) {
    return specialization
  }

  return ''
}

export function formatDoctorSpecialization(doctor) {
  if (!doctor || typeof doctor !== 'object') {
    return ''
  }

  const specialization = normalizeValue(
    doctor.doctor_specialization || doctor.doctor_specialization_ru || doctor.specialization_name || doctor.specialization_ru || doctor.specialization
  )
  const academicDegree = normalizeValue(doctor.academic_degree || doctor.academic_degree_ru || doctor.doctor_academic_degree || doctor.doctor_academic_degree_ru)
  const academicTitle = normalizeValue(doctor.academic_title || doctor.academic_title_ru || doctor.doctor_academic_title || doctor.doctor_academic_title_ru)

  return [specialization, academicDegree, academicTitle]
    .filter(Boolean)
    .join(', ')
}

export function formatDoctorMedicalInfo(doctor) {
  if (!doctor || typeof doctor !== 'object') {
    return ''
  }

  const specialization = getDoctorPrimarySpecialization(doctor)
  const roleInOrg = getDoctorPrimaryRoleInOrg(doctor)
  const academicDegree = normalizeValue(doctor.academic_degree || doctor.academic_degree_ru || doctor.doctor_academic_degree || doctor.doctor_academic_degree_ru)
  const academicTitle = normalizeValue(doctor.academic_title || doctor.academic_title_ru || doctor.doctor_academic_title || doctor.doctor_academic_title_ru)

  const headline = [specialization, roleInOrg]
    .filter((value, index, values) => value && values.indexOf(value) === index)
    .join(' · ')

  const academicInfo = [academicDegree, academicTitle]
    .filter((value, index, values) => value && values.indexOf(value) === index)
    .join(', ')

  return [headline, academicInfo]
    .filter(Boolean)
    .join(', ')
}

export function getLocalizedCityName(city, locale = 'ru') {
  if (!city || typeof city !== 'object') {
    return ''
  }

  if (locale === 'kk') {
    return normalizeValue(
      city.name_kz || city.primary_name || city.name_ru || city.name
    )
  }

  return normalizeValue(
    city.name_ru || city.name || city.primary_name || city.name_kz
  )
}

export function getLocalizedClinicName(clinic, locale = 'ru') {
  if (!clinic || typeof clinic !== 'object') {
    return ''
  }

  if (locale === 'kk') {
    return normalizeValue(clinic.name_kz || clinic.primary_name || clinic.name)
  }

  return normalizeValue(clinic.name || clinic.primary_name || clinic.name_kz)
}
